<div mat-dialog-title>
    <button class="close" mat-dialog-close aria-label="Close">
        <mat-icon [svgIcon]="'close'" aria-hidden></mat-icon>
    </button>
</div>
<div class="billing-dialog-content" mat-dialog-content>
    <div class="dialog-content-container">
        <div class="message-container">
            <p> For your security, please log in to Genesys Cloud to verify your billing permissions. </p>
        </div>
        <div class="required-field-hint">
            <span>* Required fields</span>
        </div>
        <form [formGroup]="billingForm" class="form-fields">
            <mat-form-field class="full-width">
                <mat-label>Genesys Cloud Organization Region&nbsp;</mat-label>
                <mat-select formControlName="region">
                    @for (option of filteredSelectOptions(); track option.auth) {
                        <mat-option [value]="option.auth">
                            {{ option.aws }} ({{ option.label }} - {{ option.short }})
                        </mat-option>
                    }
                </mat-select>
                <mat-error> Region selection is required </mat-error>
            </mat-form-field>

            <!-- <mat-form-field appearance="outline" class="full-width">
                <mat-label>Genesys Cloud Organization Short Name&nbsp;</mat-label>
                <input matInput formControlName="organizationName" placeholder="Enter organization short name" />
                <mat-error *ngIf="billingForm.get('organizationName')?.hasError('required')">
                    Organization name is required
                </mat-error>
                <mat-error *ngIf="billingForm.get('organizationName')?.hasError('notFound')">
                    Organization not found. Please check the name and try again.
                </mat-error>
            </mat-form-field> -->
        </form>
        <div class="message-container-after">
            <p>
                Select your region. When you click "Log in to Genesys Cloud", you'll be briefly redirected to the
                Genesys Cloud login page to verify your permissions. After validating, you'll be returned here, where
                you can review your billing information.
            </p>
        </div>
    </div>
</div>
<mat-dialog-actions>
    <button
        class="sign-in"
        [disabled]="billingForm.invalid || isLoading()"
        (click)="loginToGenesysCloud()"
        aria-label="Log in to Genesys Cloud">
        @if (isLoading()) {
            <span>Redirecting...</span>
        } @else {
            <span>Log in to Genesys Cloud</span>
        }
    </button>
</mat-dialog-actions>
